// deps
import styled, { keyframes } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const NEGATIVE_LIGHT_SHADOW = "0px -3px 6px rgba(40, 44, 63, 0.1)";
const BOTTOM_SHEET_NEGATIVE_SHADOW = "0px -12px 28px rgba(27, 30, 36, 0.1)";

export const BottomSheetContentContainer = styled.div(({ theme }) => ({
    overflowX: "hidden",
    overflowY: "auto",
    boxShadow: BOTTOM_SHEET_NEGATIVE_SHADOW,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
}));

// Container for loading state
export const LoadingContainer = styled.div(({ theme }) => ({
    borderRadius: `${theme.cornerRadius.large} ${theme.cornerRadius.large} 0 0`,
    boxShadow: NEGATIVE_LIGHT_SHADOW,
    padding: `${theme.spacing.xxLarge} ${theme.spacing.medium}`,
}));

export const ContainerErrorWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: `${theme.spacing.xLarge} ${theme.spacing.medium}`,
}));

export const ContainerBtnWrapper = styled.div(({ theme }) => ({
    padding: `${theme.spacing.xxSmall} ${theme.spacing.medium} ${theme.spacing.medium}`,
}));

export const ApplyingText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.xLarge,
}));

export const ErrorText = styled(Text)<{ isPaymentListingCouponCard?: boolean }>(
    ({ theme, isPaymentListingCouponCard }) => ({
        marginLeft: isPaymentListingCouponCard ? theme.spacing.xSmall : theme.spacing.medium,
        marginRight: theme?.spacing?.large,
    }),
);

export const progress = keyframes`
    0% {
        left: -275px;
    }
    100% {
        left: 100%;
    }
`;

export const ProgressBar = styled.div`
    position: absolute;
    height: 6px;
    width: 275px;
    background: ${(props) => props.theme.colors[props.theme.colorMode].primary};
    animation: ${progress} 2s infinite;
    border-radius: ${(props) => props.theme.cornerRadius.xxSmall};
    &::before {
        content: "";
        display: block;
        position: relative;
        width: 10px;
        height: 6px;
        background: ${(props) => props.theme.colors[props.theme.colorMode].background_Primary};
        left: 230px;
    }
`;

export const CloseIconContainer = styled.div`
    position: absolute;
    top: ${(props) => props.theme.spacing.small};
    right: ${(props) => props.theme.spacing.small};
    z-index: 1;
`;
